import React, { useState } from 'react'
import { unlockMobile, unlockEmail } from "../../../api/requestAxios/userInfo";
import Modal from "react-bootstrap/Modal";
import { Button } from 'react-bootstrap';
import { InfoToast } from '../../../shared';
import constants from '../../../constants/constants';

const ToUnlock = ({ actionType, id, style }) => {
  const [showModal, setShowModal] = useState(false)
  const [waiting, setWaiting] = useState(false)

  const handleConfirm = async () => {
    setWaiting(true)
    if (actionType === "mobile") {

      const result = await unlockMobile(id)
      if (result.status === 200) {
        setWaiting(false)
        setShowModal(false)
        InfoToast(constants.UnlockChangingMobileSuccess)

      }


    } else {
      const result = await unlockEmail(id)

      setWaiting(false)

    }
  }
  return (
    <>
      <span {...{ style }} className='user-unlock-spn' onClick={() => setShowModal(true)}>
        <svg viewBox="0 0 24 24">
          <path d="M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10A2,2 0 0,1 6,8H15V6A3,3 0 0,0 12,3A3,3 0 0,0 9,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17Z" />
        </svg>


      </span>
      <Modal
        size="sm"
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-unlock-confirm"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {`رفع محدودیت تغییر ${actionType === "mobile" ? "موبایل" : "ایمیل"}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {`آیا رفع محدودیت ${actionType === "mobile" ? "موبایل" : "ایمیل"} مشترک را تایید می‌کنید؟`}
          </p>
          <div className='mt-5'>

            <Button variant="primary" className=" mt-5 w-100" size="lg" disabled={waiting} onClick={handleConfirm}>
              تایید رفع محدودیت
            </Button>

          </div>
        </Modal.Body>
      </Modal>



    </>

  )
}

export default ToUnlock